var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.85 14.47C17.7184 14.4708 17.5879 14.4456 17.4661 14.3958C17.3442 14.346 17.2334 14.2727 17.14 14.18L11.89 8.92003L6.62999 14.18C6.44263 14.3663 6.18918 14.4708 5.92499 14.4708C5.66081 14.4708 5.40736 14.3663 5.21999 14.18C5.12626 14.0871 5.05187 13.9765 5.0011 13.8546C4.95033 13.7327 4.92419 13.602 4.92419 13.47C4.92419 13.338 4.95033 13.2073 5.0011 13.0855C5.05187 12.9636 5.12626 12.853 5.21999 12.76L11.22 6.76003C11.4074 6.57378 11.6608 6.46924 11.925 6.46924C12.1892 6.46924 12.4426 6.57378 12.63 6.76003L18.63 12.76C18.7237 12.853 18.7981 12.9636 18.8489 13.0855C18.8997 13.2073 18.9258 13.338 18.9258 13.47C18.9258 13.602 18.8997 13.7327 18.8489 13.8546C18.7981 13.9765 18.7237 14.0871 18.63 14.18C18.5284 14.2815 18.4062 14.36 18.2716 14.41C18.137 14.4601 17.9932 14.4805 17.85 14.47Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronUp);
export default __webpack_public_path__ + "static/media/IconChevronUp.9f7ab1bc88dd88bb5d137d36101bc902.svg";
export { ForwardRef as ReactComponent };